import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { mergeMap } from 'rxjs';

import { GuestCartActions } from '../actions';
import { IGuestCartResponse } from '../models/guest.models';
import { MarketingFacade } from '../facades/marketing.facade';

@Injectable({
  providedIn: 'root',
})
export class GuestCartEffects {

  constructor(
    private actions$: Actions,
    private marketingFacade: MarketingFacade,
  ) {
  }

  loadGuestCart$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GuestCartActions.loadGuestCart),
      mergeMap(action => this.marketingFacade.getGuestCartById(action.guestUserId, action.guestCartId).pipe(
        map((guestCartResponse: IGuestCartResponse) => {
          return GuestCartActions.loadGuestCartSuccess({guestCartResponse});
        }),
      )),
    ));
}
